import { connect } from 'react-redux';
import { Form, Input, Select } from 'antd';
import { useFormContext } from '../../Context';
import FunctionalitySelector from 'Components/Weaver/Input/FunctionalitySelector';

const Header = ({ branches, form, taskId, title, ...props }) => {
  const { formValues, updateFormValues } = useFormContext();
  const initialValues = formValues?.header

  return (
    <div className="task-form">
      <Form
        form={form}
        initialValues={initialValues}
        onValuesChange={(vals) => updateFormValues({ header: { ...formValues.header, ...vals } })}
      >
        <Form.Item
          label="Name"
          name="name"
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          label="Branch"
          name="branch"
        >
          <Select disabled={taskId !== 'new'}>
            {
              branches?.map((branch) =>
                <Select.Option
                  key={`task-targetBranch-${branch.id()}`}
                  value={branch.id()}
                >
                  {branch.name()}
                </Select.Option>
              )
            }
          </Select>
        </Form.Item>
        <FunctionalitySelector
          label="Functionality"
          direction="horizontal"
          form={form}
          onLeafNodeSelect={(functionality) => updateFormValues({ header: { ...formValues.header, functionality } })}
          {...props}
        />
      </Form>
    </div>
  );
};

const mapStateToProps = ({ branches }) => ({
  branches: branches.branches,
});

export default connect(mapStateToProps)(Header);
